import ApiManager from '../api/crud-manager';

class AddressLookup {
  constructor(config) {
    this.config = {
      forms: () => document.querySelectorAll('[data-module*="geolocate"]'),
      postalCodeRegex: /^[0-9]{4}[a-zA-Z]{2}$/g,
      apiManager: new ApiManager(),
      ...config
    };
    this.resolveLocation = this.resolveLocation.bind(this);
  }

  static findParentByTag(element, tag) {
    // eslint-disable-next-line
    while ((element = element.parentElement) && element.tagName !== tag);
    return element;
  }

  resolveLocation(event) {
    const { postalCodeRegex } = this.config;
    const { target } = event;

    const moduleElement = target.closest('[data-module*="geolocate"]');
    if (!moduleElement) return;
    const form = AddressLookup.findParentByTag(target, 'FIELDSET');
    if (!form) return;
    const inputNamePrefix = moduleElement.dataset.inputNamePrefix || '';
    const targetInput = target.getAttribute('name');

    if (!targetInput) return;
    const whitelistTargetInput = [`${inputNamePrefix}houseNumber`, `${inputNamePrefix}postalCode`];
    if (!whitelistTargetInput.includes(targetInput)) return;

    const postalCodeInput = form.elements.namedItem(`${inputNamePrefix}postalCode`);
    const houseNumberInput = form.elements.namedItem(`${inputNamePrefix}houseNumber`);

    if (!postalCodeInput || !houseNumberInput) return;

    if (
      postalCodeInput.value.length <= 0 ||
      houseNumberInput.value.length <= 0 ||
      !postalCodeInput.value.match(postalCodeRegex)
    )
      return;

    const cbName = `jsonp_callback_${Math.floor(10000 * Math.random())}`;
    const script = document.createElement('script');

    window[cbName] = data => {
      delete window[cbName];
      document.body.removeChild(script);

      if (data !== null && data.constructor === Object) {
        const street = form.elements.namedItem(`${inputNamePrefix}street`);
        if (street) street.value = data.Street;

        const city = form.elements.namedItem(`${inputNamePrefix}city`);
        if (city) city.value = data.City;
      }
    };

    script.src = `https://api.pangaea.nl/api/GeoEncoding?${`postalCode=${
      postalCodeInput.value
    }&houseNumber=${houseNumberInput.value}`}&callback=${cbName}`;
    document.body.appendChild(script);
  }

  init() {
    const { forms } = this.config;

    forms().forEach(form => {
      form.addEventListener('blur', this.resolveLocation, true);

      const postalcodeInput = form.elements.namedItem('postalCode');
      if (!postalcodeInput) return;

      postalcodeInput.addEventListener('keyup', e => {
        let { value } = e.target;
        if (!value || value === '') return;
        value = value.toUpperCase();
      });
    });
  }
}

export default AddressLookup;
